import {Injectable} from '@angular/core'
import {HttpClient,HttpHeaders,HttpParams} from '@angular/common/http'
import {Observable} from 'rxjs'


@Injectable()
export class ScvEmployeeService{

    url="http://localhost:8080/hello"

    constructor(private http:HttpClient){
    }
    
    getEmployees():Observable<any>{
        return this.http.get(this.url)
    }

   
}